import React from "react"
import styles from "./chevron-button.module.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronRight } from "@fortawesome/free-solid-svg-icons"

export default ({ link }) => (
    <a href={link} className={styles.chevronButton}>
      <FontAwesomeIcon  icon={faChevronRight} size={"2x"}/>
    </a>
)